var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComprobantes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25004 9.33333L17.5934 3.43C17.7333 3.36303 17.8852 3.32463 18.0401 3.31706C18.1951 3.30949 18.35 3.3329 18.4958 3.38591C18.6415 3.43893 18.7753 3.52049 18.8892 3.62581C19.0031 3.73114 19.0948 3.85812 19.159 3.99933L21.5834 9.33333M7.00004 11.6667V9.33333M7.00004 16.3333V17.5M7.00004 22.1667V24.5M4.66671 9.33333H23.3334C24.622 9.33333 25.6667 10.378 25.6667 11.6667V22.1667C25.6667 23.4553 24.622 24.5 23.3334 24.5H4.66671C3.37804 24.5 2.33337 23.4553 2.33337 22.1667V11.6667C2.33337 10.378 3.37804 9.33333 4.66671 9.33333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprobantes);
export default __webpack_public_path__ + "static/media/comprobantes.e126f643c6baa60835dd41495d23c584.svg";
export { ForwardRef as ReactComponent };